import { cn } from '@/utils/cn';

interface TeeSelectableChipProps {
  label: string;
  selected: boolean;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
}

export function TeeSelectableChip({
  label,
  selected,
  onClick,
  disabled,
  className,
}: TeeSelectableChipProps) {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
      aria-pressed={selected}
      className={cn(
        selected
          ? 'px-3 py-1.5 rounded-[6px] border text-[12px] font-semibold transition-colors bg-[rgba(12,61,45,0.10)] border-[var(--border-active)] text-[var(--color-forest)]'
          : 'px-3 py-1.5 rounded-[6px] border text-[12px] font-semibold transition-colors bg-[var(--background-card)] border-[var(--border-default)] text-[var(--text-content-title)] hover:bg-[var(--background-card-hover)] disabled:opacity-50 disabled:cursor-not-allowed',
        className,
      )}
    >
      {label}
    </button>
  );
}
